"use strict";

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = actionWith;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _errors = require("../errors");

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Evaluate a type descriptor to an FSA
 * @param {Object} descriptor - A type descriptor
 * @param {Array} args - The arguments for `payload` and `meta` function properties
 * @returns {Promise} A promise that is resolved with the action to be dispatched.
 */
function actionWith(descriptor) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return _promise.default.all([new _promise.default(function (resolve) {
    if (typeof descriptor.payload === 'function') {
      resolve(descriptor.payload.apply(descriptor, args));
    } else {
      resolve(descriptor.payload);
    }
  }), new _promise.default(function (resolve) {
    if (typeof descriptor.meta === 'function') {
      resolve(descriptor.meta.apply(descriptor, args));
    } else {
      resolve(descriptor.meta);
    }
  })]).then(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        payload = _ref2[0],
        meta = _ref2[1];

    return _objectSpread(_objectSpread({}, descriptor), {}, {
      meta: meta,
      payload: payload
    });
  }).catch(function (error) {
    return _objectSpread(_objectSpread({}, descriptor), {}, {
      error: true,
      payload: new _errors.InternalError(error.message),
      meta: undefined
    });
  });
}